<template>
<v-row no-gutters>
    <v-col cols="12" sm="6" md="6">
        <v-data-table :headers="headers" :items="modules" :search="search" sort-by="module_name" class="elevation-1">
            <template v-slot:top>
            <v-toolbar flat color="white">
                <v-toolbar-title>Module Access and Permisions</v-toolbar-title>
                <div class="flex-grow-1"></div>
                    <v-text-field v-model="search" append-icon="mdi-search" label="Search" single-line hide-details></v-text-field>
                <v-dialog v-model="dialog" max-width="500px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark class="mb-2" v-on="on">New Module</v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                        <v-container>
                            <v-row>
                            <v-col cols="12" sm="6" md="4" v-for="header in headers" :key="header.value">
                                <v-text-field v-if="header.value != 'action'" v-model="editedItem[header.value]" :label="header.text"></v-text-field>
                            </v-col>
                            </v-row>
                        </v-container>
                        </v-card-text>

                        <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
            </template>
            <template v-slot:item.action="{ item }">
                <v-icon small class="mdi mdi-border-color" @click="editItem(item)"></v-icon>
                <v-icon small class="mdi mdi-delete" @click="deleteItem(item)"></v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
      </v-col>
      
      <v-col cols="6" md="5">
            <v-card class="mt-0 mx-auto pa-md-4 mx-lg-auto" elevation="4"  max-width="450">  
                    <h3>Groups with access:</h3>
               <v-chip-group multiple column active-class="primary--text">
                    <v-chip v-for="group in groups" :key="group.id">
                        {{ group.name }}
                </v-chip>
                </v-chip-group>
            <v-divider></v-divider>
                    <h3> Their rights: </h3> 
                <v-treeview selectable :items="items"></v-treeview>
            </v-card>
      </v-col> 
      
    </v-row>
  
</template>

<script>
  export default {
    name: 'ModulesDataTable',
    data: () => ({
      dialog: false,
      show: false,
      search: '',
      headers: [
        {
          text: 'Name',
          align: 'left',
          sortable: false,
          value: 'module_name',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      modules: [],
      editedIndex: -1,
      editedItem: {
        module_name: '',
      },
      defaultItem: {
        module_name: '',
      },
      groups: [
          {id: 1, name:'Administrator'},
          {id: 2, name:'Users'},
          {id: 3, name:'Radioroom Users'},
          {id: 4, name:'Harbour Clerks'}
      ],
      items: [
        {
          id: 1,
          name: 'Rights and Permisions',
          children: [
            { id: 1, name: 'All Permisions' },
            { id: 2, name: 'Read and Write' },
            { id: 3, name: 'Readonly' },
          ],
        },
      ],
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Module' : 'Edit Module'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.modules = [
            {module_name: 'chief-pilot-log'}, {module_name: 'radio-log'}, {module_name: 'payment-charges'},
            {module_name: 'user-management'}, {module_name: 'vessels-management'}
            ]
      },

      editItem (item) {
        this.editedIndex = this.modules.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.modules.indexOf(item)
        confirm('Are you sure you want to delete this item?') && this.modules.splice(index, 1)
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.modules[this.editedIndex], this.editedItem)
        } else {
          this.modules.push(this.editedItem)
        }
        this.close()
      },
    },
  }
</script>